import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function Card({ title, right, children, className, headingId, id, tabIndex, ariaLabel, flush, dashed, density = 'default' }) {
    const compact = density === 'compact';
    const pad = compact ? 'var(--sp-4) var(--sp-5)' : 'var(--space-4)';
    const gap = compact ? 'var(--sp-3)' : 'var(--space-3)';
    const head = title ? (_jsxs("div", { "data-part": "card-head", style: {
            display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap, flexWrap: 'wrap',
            ...(flush ? { padding: pad } : {}),
        }, children: [_jsx("h2", { id: headingId, style: { margin: 0, fontSize: compact ? 'var(--fs-md)' : 'var(--font-size-md)', fontWeight: compact ? 600 : undefined, color: 'var(--text)' }, children: title }), right] })) : (right);
    return (_jsxs("section", { className: className, id: id, tabIndex: tabIndex, "aria-labelledby": title && headingId ? headingId : undefined, "aria-label": !(title && headingId) ? ariaLabel : undefined, "data-card": true, style: {
            border: `1px ${dashed ? 'dashed' : 'solid'} ${dashed ? 'var(--border-strong)' : 'var(--border)'}`,
            borderRadius: compact ? 'var(--radius-lg)' : 'var(--radius-card)',
            background: 'var(--surface)',
            padding: flush ? 0 : pad,
            fontFamily: 'var(--font-ui)',
            display: 'grid',
            gap: flush ? 0 : gap,
            minWidth: 0,
            ...(flush ? { overflow: 'hidden' } : {}),
        }, children: [head, children] }));
}
//# sourceMappingURL=Card.js.map